export const Profile = {
	idno: null,
	first_name: null,
	last_name: null,
	suffix: null,
	mobile_no: null,
	position: null,
	date_hired: null,
};
